

import {Component, Prop} from 'vue-property-decorator'

import {LatLon} from './models/LatLon'
import NMapChildren from './NMapChildren.vue'

@Component({
  components: {},
})
export default class NMapPolyline extends NMapChildren {
  @Prop() public points!: LatLon[]

  @Prop({default: 4}) public readonly lineWidth!: number
  @Prop({default: '#ff0000'}) public readonly color!: string

  public render(createElement: any) {
    return null
  }

  public init() {
    this.item = this.getNMap().providerInstance.addPolyline(this.points, this.lineWidth, this.color)
  }
}
